module.exports = __webpack_public_path__ + "static/media/RealTimeNotification.ca26fc32.svg";